export const returnString = (input: string | boolean | undefined, fallback?: string): string => {
  switch (typeof input) {
    case 'string':
      return input;
    case 'undefined':
      return fallback ? fallback : '';
    default:
      return input ? 'true' : fallback ? fallback : 'false';
  }
};
